/** Upcoming (planned) panel section for TodayViewPanels. */
import Panel from '@/components/ui/Panel';
import TodaySectionList from './TodaySectionList';
import {
  TODAY_PANEL_A11Y,
  TODAY_PANEL_FLAT_CLASS,
} from './todayViewPanelsHelpers';

export function TodayUpcomingPanelSection({
  t,
  isBattlefield,
  showUpcoming,
  displayUpcomingTasks,
  topActionableTaskId,
  tasksMap,
  selectedTaskIds,
  setSelectedTaskIds,
}) {
  if (!showUpcoming) {
    return null;
  }

  return (
    <Panel
      flat
      contentClassName={TODAY_PANEL_FLAT_CLASS}
      title={t('todayviewcontent.upcomingTasks', 'Planned')}
      count={displayUpcomingTasks.length}
      defaultOpen
      testId="panel-upcoming"
      {...TODAY_PANEL_A11Y}
    >
      <TodaySectionList
        isBattlefield={isBattlefield}
        variant="simple"
        tasks={displayUpcomingTasks}
        listId="upcoming-list"
        menuSurface="today-upcoming"
        topActionableTaskId={topActionableTaskId}
        showPlayButtonAlways={false}
        tasksMap={tasksMap}
        emptyMessage={t(
          'todayviewcontent.upcomingEmpty',
          'No planned tasks.',
        )}
        selectedTaskIds={selectedTaskIds}
        onSelectionChange={setSelectedTaskIds}
      />
    </Panel>
  );
}
